module.exports = __webpack_public_path__ + "static/img/frame 1.f1112fc7.png";